export default "__VITE_ASSET__3eb6bf72__$_?react__"